import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

import GetElementID from './_GetElementID.jsx';
import GetItemNumber from './_GetItemNumber.jsx';

export default class MethodItemMapping extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section className="api-method-landing">
				<h1 className="text--xxl-title l-margin-bottom--xl">Item Mapping</h1>
				<section>
					<p><strong>Please note the following:</strong></p>
					<ul className="api-method-landing__intro">
						<li>It does not guarantee that you can get the complete mapping of items</li>
						<li>It provides item mappings only for PARTs</li>
						<li>Item mapping may not be one-to-one</li>
					</ul>
				</section>
				<GetElementID/>
				<GetItemNumber/>
			</section>
		);
	}
}